import "./navbar.css";

export const Navbar = ({ onLinkClick, activeSection }) => {
    const links = [
        { name: "home", label: "Home" },
        { name: "sobre", label: "Sobre Mim" },
        { name: "projetos", label: "Projetos" },
        { name: "contatos", label: "Contatos" },
    ];

    return (
        <nav className="navbar">
            <ul className="navbar-list">
                {links.map((link) => (
                    <li
                        key={link.name}
                        onClick={() => onLinkClick(link.name)}
                        className={`navbar-item ${activeSection === link.name ? "active" : ""}`}
                    >
                        {link.label}
                    </li>
                ))}
            </ul>
        </nav>
    );
};
